import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_phone",
  "use": "icon_phone-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"icon_phone\"><path d=\"M20.121 15.26l-2.542-.29c-.61-.07-1.21.14-1.64.57l-1.842 1.84a15.05 15.05 0 01-6.595-6.59l1.852-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2.002 2.002 0 00-1.992-1.77h-1.73c-1.132 0-2.072.94-2.002 2.07.53 8.54 7.365 15.36 15.9 15.89 1.132.07 2.072-.87 2.072-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol